import { baseUrl } from './config'

export const sleep = (ms: number) => new Promise<void>(r => setTimeout(r, ms))

export const avaterUrl = (id: string) => `${baseUrl}avater/${id}.jpeg`